class Footer {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("footer", () => ({
                    handleCookies() {
                        __tcfapi("displayConsentUi", 2, function () {
                            __uspapi("displayUspUi");
                        });
                    },
                }));
            },
            { once: true },
        );
    }
}

new Footer();
